<template>
  <transition name="modal-fade">
    <div
      :class="['cu-modal', className]"
      v-show="show"
      @keyup.esc="onEsc"
      tabindex="-1"
    >
      <div class="cu-modal-mask" v-if="mask" @click="$emit('hide')" />
      <!-- <transition :name="`modal-${animation}`"> -->
      <div class="cu-modal-dialog" v-show="show">
        <span class="cu-modal-close" v-if="closeButton" @click="$emit('hide')">
          <slot name="btn">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.4 55">
              <path fill="#c80004" d="M0 0h60.4v55H0z" />
              <g fill="none" stroke="#000" stroke-miterlimit="10">
                <path d="M45.8 10.7L12.4 44.2M12.4 10.7l33.4 33.5" />
              </g>
            </svg>
          </slot>
        </span>
        <slot></slot>
      </div>
      <!-- </transition> -->
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    animation: {
      type: String,
      default: "zoom"
    },
    mask: {
      type: Boolean,
      default: true
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    className: {
      type: String,
      default: ""
    }
  },

  computed: {},

  methods: {
    onEsc() {
      this.show && this.$emit("hide");
    }
  },

  watch: {
    show(show) {
      show &&
        this.$nextTick(() => {
          this.$el.focus();
        });
    }
  }
};
</script>
